import React from "react";
import Breadcrumbs from "../../../utils/components/Breadcrumbs";
import Button from "../../../utils/components/Button";
import Table from "../../../utils/components/Table";
import keepOrganizer from "../../../utils/functions/keepOrganizer";
import LoadingOverlay from "../../../utils/components/LoadingOverlay";

const SyncPanelView = ({
    revaLineups,
    tournaments,
    lineups,
    selectedTournamentId,
    setSelectedTournamentId,
    handleSyncLineup,
    loadingReva,
    loadingTournaments,
    loadingLineups,
}) => {
    const getLineupSyncStatus = (lineupId) => {
        if (!Array.isArray(revaLineups)) return null;
        return revaLineups.find((rl) => rl.external_entity_id === lineupId);
    };

    const rows = (lineups || []).map((lineup) => {
        const revaLineup = getLineupSyncStatus(lineup.id);
        const lineupName = lineup.team?.name || lineup.name;
        return {
            ...lineup,
            status: revaLineup ? (
                <span className="label label-primary">Sincronizado</span>
            ) : (
                <span className="label label-warning">No Sincronizado</span>
            ),
            reva_actions: (
                <div className="btn-separated-group">
                    {!revaLineup ? (
                        <Button
                            className="btn btn-xs btn-info"
                            title="Sincronizar"
                            onClick={() => handleSyncLineup(lineup)}
                            loading={loadingReva.syncLineup}
                        />
                    ) : (
                        <span className="text-muted">Ya vinculado</span>
                    )}
                </div>
            ),
        };
    });

    return (
        <>
            <Breadcrumbs
                title="Sincronizar Reva"
                opts={[
                    { title: "Inicio", path: keepOrganizer("/") },
                    { title: "Panel Financiero", path: keepOrganizer("/financial-panel") },
                    { title: "Sincronizar", active: true },
                ]}
            />

            <div className="row m-t-md">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>Vincular Equipos con Reva</h5>
                            <div className="ibox-tools">
                                <select
                                    className="form-control input-sm"
                                    value={selectedTournamentId}
                                    onChange={(e) => setSelectedTournamentId(e.target.value)}
                                >
                                    <option value="">Seleccione un torneo...</option>
                                    {tournaments.map((t) => (
                                        <option key={t.id} value={t.id}>
                                            {t.name} ({t.year})
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <LoadingOverlay loading={loadingReva.loadLineups || loadingTournaments.loadAllTournaments}>
                            <div className="ibox-content">
                                {selectedTournamentId ? (
                                    <Table
                                        loading={loadingLineups.loadAllLineups}
                                        headers={[
                                            { label: "Equipo", ref: "display_name" },
                                            { label: "Estado Reva", ref: "status" },
                                            { label: "Acciones Reva", ref: "reva_actions" },
                                        ]}
                                        rows={rows.map(r => ({ ...r, display_name: r.team?.name || r.name }))}
                                        notFoundMessage="No se encontraron equipos para este torneo."
                                    />
                                ) : (
                                    <div className="text-center p-md">
                                        <i className="fa fa-refresh fa-3x text-muted"></i>
                                        <h4 className="m-t-md">Seleccioná un torneo para sincronizar sus equipos con Reva.</h4>
                                    </div>
                                )}
                            </div>
                        </LoadingOverlay>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SyncPanelView;
